import { CreativeRepository } from '../Creative'
import { CreativeFolderRepository } from '.'

export class CreativeFolderModel {
  constructor(data = {}) {
    const { id, name, isRoot, ownerProfileId } = data

    this.id = id
    this.name = name
    this.isRoot = isRoot || false
    this.ownerProfileId = ownerProfileId

    // isRoot: true の場合、 children がセット可能
    if (isRoot) this.children = []
    this.creatives = []
  }

  static assign(data) {
    return new CreativeFolderModel(data)
  }

  get isNew() {
    return this.id == null
  }

  get treeKey() {
    return `folder_${this.id}`
  }

  findCreativeFolder(id) {
    if (this.isNew) throw new Error('走査できません')
    if (this.id === id) return this
    if (!this.children) return null
    return this.children.find(cf => cf.findCreativeFolder(id) != null)
  }

  async getCreatives({ creativeTypes = undefined }) {
    if (this.isNew) throw new Error('取得できません')
    const children = this.isRoot ? this.children : []
    const creativeFolderIds = [this.id, ...children.map(cf => cf.id)]
    const res = await CreativeRepository.search({
      ownerProfileId: this.ownerProfileId,
      creativeFolderIds,
      creativeTypes,
    })
    return res.items
  }

  async fetchCreatives() {
    this.creatives = await this.getCreatives({})
  }

  addNewChild() {
    if (!this.children) return
    const child = new CreativeFolderModel({ id: 'hoge', name: 'foo' })
    this.children = [child, ...this.children]
  }
}

export class AddCreativeFolderFormModel {
  constructor(data) {
    const { ownerProfileId } = data
    this.ownerProfileId = ownerProfileId
    this.name = ''
    this.isRoot = false // サブフォルダは常にfalse
  }

  get isValid() {
    return this.name.length > 0
  }

  async save() {
    return await CreativeFolderRepository.create(this)
  }
}

export class EditCreativeFolderFormModel {
  constructor(data) {
    const { id, name } = data

    this.id = id
    this.name = name
  }

  get isValid() {
    return this.name.length > 0
  }

  async save() {
    return await CreativeFolderRepository.update(this)
  }
}
